import {Component, OnInit} from "@angular/core";
import {Field} from "../models/field.model";
import {Settings} from "../../multiselect/multiselect.config";
import {ENVIRONMENT} from "../../../../environments/environment";

@Component({
	selector: "tig-form-select-multiple-check",
	template: `
        <div
			class="form-group"
			[formGroup]="OBJ_form_group"
			[ngClass]="{'has-error': isInvalid()}">
			<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
            <label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
				<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
				   [tooltip]="tooltipTemplate"
				   placement="top"
				   triggers="click"
				   containerClass="tig-tooltip"
				   delay="50"></i>
                <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
            <div class="col-lg-8">
                <tig-multiselect
					[formControlName]="OBJ_field_config.name"
					[items]="OBJ_field_config.options"
					[settings]="settings"
					(selectedEvent)="selected($event)"
					[disabled]="OBJ_field_config?.readonly"
                ></tig-multiselect>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
                <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
            </div>
        </div>
		<div class="form-group" *ngIf="STR_route_to_self">
			<div class="col-lg-2 control-label"></div>
			<div class="col-lg-8">
				<a href="{{STR_route_to_self}}" target="_blank">{{"oMisc.sEditEntry"|translate}}</a>
			</div>
		</div>
	`
})
export class FormSelectMultipleCheckComponent extends Field implements OnInit
{

	STR_route_to_self = "";

	/**
	 * Attributes
	 */
    // Settings configuration
    settings: Settings = {
		id: "id", // attribute name in object for the identifier
		text: "title", // attribute name in object for the text
		enableFilter: true,
		placeholder: "please_select",
        filterPlaceholder: "filter",
        multiple: false,
		options: null
    };


	/**
	 * Function > ngOnInit
	 * @return {any}
	 */
	ngOnInit(): void
	{

		// console.log("Initializing form-select-multiple-check", this.OBJ_field_config);
        this.settings.multiple = (this.OBJ_field_config.multiple != null)?this.OBJ_field_config.multiple:true;
		this.settings.options = (this.OBJ_field_config._links.options != null)?this.OBJ_field_config._links.options:null;


		// If this is an assignment offer the user a link to the assigned object
		if (
			this.OBJ_field_config.object_structure &&
			this.OBJ_field_config.object_structure.classname.includes("ImageAssignment") &&
			this.OBJ_field_config.value.length > 0
		)
		{
			let STR_url = "";

			if (ENVIRONMENT.env === 'development') {
				STR_url = 'wcms/';
			} // end if

			if(this.OBJ_field_config.object_structure.classname.includes("ImageAssignment"))
			{
				this.STR_route_to_self = STR_url + 'upload/images/' + this.OBJ_field_config.value[0];
			}
			else if(this.OBJ_field_config.object_structure.classname.includes("FileAssignment"))
			{
				this.STR_route_to_self = STR_url + 'upload/files/' + this.OBJ_field_config.value[0];
			} // end if

		} // end if

	} // end function ngOnInit


	/**
	 * Function > selected
	 * @param {object} OBJ_value
	 */
	public selected(OBJ_value): void
	{
		this.OBJ_field_config.value = OBJ_value;
		this.markAsDirtyAndTouched();
	} // end function selected


} // end class FormSelectMultipleCheckComponent
